import React, { useEffect } from 'react'
import Header from '../header'
import Filter from '../filter'
import PincodeSubHeader from '../pincode-subheader'
import DisplaySlots from '../display-slots'
import DisplayBanners from '../display-banners'
import { style } from './style'

export default function SlotFinder() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div>
      <Header />
      <div style={style.slotsContainer}>
        <div style={{ padding: '0 8px', width: '100%' }}>
          <PincodeSubHeader />
          <Filter />
        </div>
        <div style={style.listOfSlots}>
          <DisplaySlots />
          <DisplayBanners />
        </div>
      </div>
    </div >
  )
}